// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    //Mon Profil 
    document.addEventListener("DOMContentLoaded", function() {
        const habitantButton = document.querySelector(".access__button--habitant");
        const visiteurButton = document.querySelector(".access__button--visiteur");
        const habitantBloc = document.getElementById("accessHabitant");
        const visiteurBloc = document.getElementById("accessVisiteur");
    
        // Par défaut c'est le profil habitant qui est visible
        habitantBloc.classList.add("visible");
        visiteurBloc.classList.add("hidden");
    
        // Par défaut c'est le bouton habitant qui est actif
        habitantButton.classList.add("active");
    
        habitantButton.addEventListener("click", function() {
            if (!habitantButton.classList.contains("active")) {
                habitantButton.classList.add("active");
                visiteurButton.classList.remove("active");
                habitantBloc.classList.add("visible");
                habitantBloc.classList.remove("hidden");
                visiteurBloc.classList.add("hidden");
                visiteurBloc.classList.remove("visible");
            }
        });
    
        visiteurButton.addEventListener("click", function() {
            if (!visiteurButton.classList.contains("active")) {
                visiteurButton.classList.add("active");
                habitantButton.classList.remove("active");
                habitantBloc.classList.add("hidden");
                habitantBloc.classList.remove("visible");
                visiteurBloc.classList.add("visible");
                visiteurBloc.classList.remove("hidden");
            }
        });
    });  

    //Filtres agenda 
    const filterEventsBtn = document.querySelector('.home-events__filters-btn');

    filterEventsBtn.addEventListener('click', () => {
        let filterEventsCategory = document.getElementById('home-events__category').value;
        let filterEventsStartDate = document.getElementById('startDateFilterHidden').value;
        let filterEventEndDate = document.getElementById('endDateFilterHidden').value;
        
        let urlFiltersSearch = window.location.href + 'systeme/agenda/?systemeParams=events';

        if ( filterEventsCategory != '0' ) {
            urlFiltersSearch = urlFiltersSearch + "&category=" + filterEventsCategory;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsStartDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
                window.location.href = urlFiltersSearch;

                if ( filterEventEndDate != '' ) {
                    urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
                    window.location.href = urlFiltersSearch;
                }
            }

            else if ( filterEventEndDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventEndDate;
                window.location.href = urlFiltersSearch;

                if ( filterEventsStartDate != '' ) {
                    urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventsStartDate;
                    window.location.href = urlFiltersSearch;
                }
            }
        }
        
        else if ( filterEventsStartDate != '' ) {
            urlFiltersSearch = urlFiltersSearch + "&startDate=" + filterEventsStartDate;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsCategory != '0' ) {
                urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                window.location.href = urlFiltersSearch;

                if ( filterEventEndDate != '' ) {
                    urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
                    window.location.href = urlFiltersSearch;
                }
            }

            else if ( filterEventEndDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
                window.location.href = urlFiltersSearch;

                if ( filterEventsCategory != '0' ) {
                    urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                    window.location.href = urlFiltersSearch;
                }
            }
        }
        
        else if ( filterEventEndDate != '' ) {
            urlFiltersSearch = urlFiltersSearch + "&endDate=" + filterEventEndDate;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsStartDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
                window.location.href = urlFiltersSearch;

                if ( filterEventsCategory != '0' ) {
                        urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                        window.location.href = urlFiltersSearch;
                    }
                }

            else if ( filterEventsCategory != '0' ) {
                urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                window.location.href = urlFiltersSearch;

                if ( filterEventsStartDate != '' ) {
                    urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
                    window.location.href = urlFiltersSearch;
                }
            }
        }
    });
}